import { render, staticRenderFns } from "./Ads1.vue?vue&type=template&id=da010240&scoped=true"
import script from "./Ads1.vue?vue&type=script&lang=js"
export * from "./Ads1.vue?vue&type=script&lang=js"
import style0 from "./Ads1.vue?vue&type=style&index=0&id=da010240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da010240",
  null
  
)

export default component.exports